// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 25/5/2023
 */

.SidePanel_container__5-4qT {
    height: -moz-fit-content;
    height: fit-content;
    margin: 1rem;
    padding: 1rem 0;
}

.SidePanel_title__tcg7x {
    padding: 1rem 1.5rem;
    font-size: 1.5rem;
    font-weight: 600;
}

.SidePanel_image__GE9NW {
    width: -moz-fit-content;
    width: fit-content;
    height: 5rem;
}

/* 
::-webkit-scrollbar {
width: 0.5rem;
}
::-webkit-scrollbar-track {
    box-shadow: inset 0 0 6px #9747FF;
}
::-webkit-scrollbar-thumb {
    background-color: #9747FF;
    outline: 1px solid #555555;
    border-radius: 0.2rem;
} */

.SidePanel_listItem__HOvd4 {
    font-size: 1rem;
    padding: 0.5rem 1.5rem;
}

.SidePanel_link__qnsaU {
    text-decoration: none;
    color: #000;
}

.SidePanel_listItem__HOvd4:active, .SidePanel_listItem__HOvd4:hover, .SidePanel_listItem__HOvd4:focus {
    color: #9747FF;
    background-color: #e1cff9;
}

.SidePanel_selected__Xtovh {
    font-size: 1rem;
    padding: 0.5rem 1.5rem;
    color: #9747FF;
    background-color: #e1cff9;
}`, "",{"version":3,"sources":["webpack://./src/Components/SidePanel/SidePanel.module.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;EAoBE;;AAEF;IACI,wBAAmB;IAAnB,mBAAmB;IACnB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,uBAAkB;IAAlB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;;;;;;;;;;;GAWG;;AAEH;IACI,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,cAAc;IACd,yBAAyB;AAC7B","sourcesContent":["/*\r\n * Copyright (c) 2023 by N-Ach (Pvt) Ltd\r\n *\r\n * ╔═╗ ╔╗    ╔═══╗  ╔╗\r\n * ║║╚╗║║    ║╔═╗║  ║║\r\n * ║╔╗╚╝║    ║║ ║╠══╣╚═╗\r\n * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║\r\n * ║║ ║║║╚══╝║╔═╗║╚═╣║║║\r\n * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝\r\n *\r\n * All rights reserved.\r\n *\r\n * This software is the confidential and proprietary information\r\n * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential\r\n * Information and shall use it only in accordance with the terms\r\n * of the license agreement you entered into with N-Ach (Pvt) Ltd.\r\n *\r\n *\r\n * @Author Dilhari Jayathunga\r\n * @Date 25/5/2023\r\n */\r\n\r\n.container {\r\n    height: fit-content;\r\n    margin: 1rem;\r\n    padding: 1rem 0;\r\n}\r\n\r\n.title {\r\n    padding: 1rem 1.5rem;\r\n    font-size: 1.5rem;\r\n    font-weight: 600;\r\n}\r\n\r\n.image {\r\n    width: fit-content;\r\n    height: 5rem;\r\n}\r\n\r\n/* \r\n::-webkit-scrollbar {\r\nwidth: 0.5rem;\r\n}\r\n::-webkit-scrollbar-track {\r\n    box-shadow: inset 0 0 6px #9747FF;\r\n}\r\n::-webkit-scrollbar-thumb {\r\n    background-color: #9747FF;\r\n    outline: 1px solid #555555;\r\n    border-radius: 0.2rem;\r\n} */\r\n\r\n.listItem {\r\n    font-size: 1rem;\r\n    padding: 0.5rem 1.5rem;\r\n}\r\n\r\n.link {\r\n    text-decoration: none;\r\n    color: #000;\r\n}\r\n\r\n.listItem:active, .listItem:hover, .listItem:focus {\r\n    color: #9747FF;\r\n    background-color: #e1cff9;\r\n}\r\n\r\n.selected {\r\n    font-size: 1rem;\r\n    padding: 0.5rem 1.5rem;\r\n    color: #9747FF;\r\n    background-color: #e1cff9;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `SidePanel_container__5-4qT`,
	"title": `SidePanel_title__tcg7x`,
	"image": `SidePanel_image__GE9NW`,
	"listItem": `SidePanel_listItem__HOvd4`,
	"link": `SidePanel_link__qnsaU`,
	"selected": `SidePanel_selected__Xtovh`
};
export default ___CSS_LOADER_EXPORT___;
